import { FetchResult } from 'apollo-boost';

import { addPricePackage, updatePricePackages } from '../../graphql/mutations/grid/pricePackages';
import {
    AddPricePackage,
    GdAddPricePackagesInput,
    GdUpdatePricePackagesInput,
    UpdatePricePackages
} from '../../typings/graphql-grid';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export class PricePackagesMutationExecutor extends BaseMutationExecutor {
    public async updatePricePackagesData(
        input: GdUpdatePricePackagesInput,
        login: string
    ): Promise<FetchResult<UpdatePricePackages & { notSynced?: boolean }>> {
        return this.client.awaitMutate<UpdatePricePackages>({
            mutation: updatePricePackages,
            variables: {
                input
            },
            login
        });
    }

    public async createPricePackage(
        input: GdAddPricePackagesInput,
        login: string
    ): Promise<FetchResult<AddPricePackage & { notSynced?: boolean }>> {
        return this.client.awaitMutate<AddPricePackage>({
            mutation: addPricePackage,
            variables: {
                input
            },
            login
        });
    }
}
